import React from 'react';
import { PenLine, Wrench, Search, Bot, Link2, Users, Globe, BarChart3 } from 'lucide-react';
import { RANKR_FEATURES } from '@/data/rankr';

const ICONS = { PenLine, Wrench, Search, Bot, Link2, Users, Globe, BarChart3 };

export default function RankrFeatures() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Everything Included</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight max-w-3xl">
          Feels like hiring an SEO team — without the agency invoice.
        </h2>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {RANKR_FEATURES.map((f) => {
            const Icon = ICONS[f.icon];
            return (
              <div key={f.title} className="bg-[#0B0B0B] p-7 hover:bg-white/[0.03] transition-colors">
                <Icon className="w-5 h-5 text-[#3B82F6]" />
                <h3 className="mt-5 font-display font-semibold text-white">{f.title}</h3>
                <p className="mt-2 text-sm text-white/55 leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}